import React from 'react';
import { dark_close } from '../../assets/images';

const UploadModal = ({ title, description, visible, handler, height , width }) => {
  return(
    <div
      className={`fixed z-20 inset-0 overflow-y-auto ${visible ? '' : 'hidden'}`}
      aria-labelledby='modal-title'  
      aria-modal='true'
    >
      <div className='flex items-end justify-center  text-center sm:block sm:p-0'>
        <div
          className='fixed inset-0 opacity-50 transition-opacity'
          aria-hidden='true'
          style={{backgroundColor : '#000000'}}
          onClick={() => handler('no')}
        >
        </div>
        <span className='sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
          &#8203;
        </span>  
        <div className="inline-block  align-bottom bg-white text-left overflow-hidden shadow-xl transform transition-75 sm:my-8 sm:align-middle sm:w-full"
        style={{zIndex : 1000, borderRadius : '10px', height : height , width : width}}
        >
        <div className="bg-white px-4 sm:p-6">
          <div className='flex flex-row-reverse '>
            <img src={dark_close} alt='closeIcon' className='cursor-pointer' onClick={() => handler('no')} />
          </div>
          <div className=" sm:flex sm:flex-col sm:items-center text-center mt-2">
            <p className='text-xl text-gray-700 font-semibold  mx-10 leading-none m-0'>{title}</p>
            {description && <p className='text-gray-600 text-base leading-none'>{description}</p>}
            <div className='flex mt-6 justify-center mb-6'>
              <button
                className='text-base bg-white font-semibold text-blue-600 px-6 py-3.5 mr-3 leading-4 rounded-md focus:outline-none'
                style={{ border: '1px solid #C7CDE0' }}
                onClick={() => handler('no')}
              >
                No, Cancel
              </button>
              <button
                className='text-base bg-blue-600 font-semibold text-white px-6 py-3.5 leading-4 rounded-md focus:outline-none'
                onClick={() => handler('yes')}
              >
                Yes, Upload
              </button>
          </div>
          </div>
        </div>
        </div>
      </div>
    </div>   
  )
};

export default UploadModal;